module.exports = __webpack_public_path__ + "officialStatic/img/gxgyjs.0c29980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/gxgyjs.png
// module id = cEUj
// module chunks = 0